'use strict';

module.exports = function (value) {
    return value;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactabular/dist-modules/formatters/identity.js
// module id = Upsw
// module chunks = 88